declare const useIsMounted: () => () => boolean;
export default useIsMounted;
